
export const financingStageChartOptions = {
  plugins: {
    legend: {
      position: "bottom"
    },
    datalabels: {
      color: "#000"
    }
  },
  maintainAspectRatio: false
};
